import { ENVIROMENT, DEVELOP_URL, PRODUCTION_URL } from "./constants";
import { PROFILE_PICTURES_BASE_URL } from "../constants/urls";
import { MOBILE_OSES } from "../constants";
import jwtDecode from "jwt-decode";
import humanFormat from "human-format";
import IS_CLIENT_RENDERED from "./isClientRendered";

export const getProfileOfFirebaseUser = (user, token) => {
  let {
    displayName,
    email,
    uid,
    photoURL,
    emailVerified,
    providerData: [{ providerId }],
  } = user.toJSON();

  const decodedToken = jwtDecode(token);
  const isAdmin = decodedToken.admin || (decodedToken.developer && ENVIROMENT !== "PRODUCTION");
  let profile = {
    name: displayName,
    email,
    picture: photoURL,
    uid,
    token,
    isAdmin,
    isEmailVerified: emailVerified,
    provider: providerId,
  };
  return profile;
};

export const getImgInSize = (url, size = "l") => {
  switch (size) {
    case "xl":
      return `${url}-xl`;
    case "l":
      return `${url}-l`;
    case "m":
      return `${url}-m`;
    case "s":
      return `${url}-s`;
    case "xs":
      return `${url}-xs`;

    default:
      return url;
  }
};

export const getProfilePictureUrl = (userId, size = "s") => `${PROFILE_PICTURES_BASE_URL}/${userId}/${size}`;

// returns a url with encoded query string based on passed options
export const constructUrl = (url, queryOptions) => {
  const query = getQueryString(queryOptions);
  return url + query;
};

export const getQueryString = options => {
  const query = [];

  for (let option in options) {
    query.push(`${option}=${encodeURIComponent(options[option])}`);
  }
  return "?" + query.join("&");
};

export const getCampaignSharingUrl = (platformName, sharingUrl, campaignName) => {
  const campaignOptions = {
    /* eslint-disable camelcase */
    twitter: {
      utm_source: "twitter",
      utm_medium: "social",
      utm_campaign: `${campaignName} tw share`,
    },
    facebook: {
      utm_source: "facebook",
      utm_medium: "social",
      utm_campaign: `${campaignName} fb share`,
    },
    linkedIn: {
      utm_source: "linkedin",
      utm_medium: "social",
      utm_campaign: `${campaignName} in share`,
    },
    /* eslint-enable */
  };

  return constructUrl(sharingUrl, campaignOptions[platformName]);
};

export const getHostName = () => {
  let host = PRODUCTION_URL;
  if(IS_CLIENT_RENDERED) {
    host = ENVIROMENT === "LOCAL" ? DEVELOP_URL : window.location.origin;
  }
  return host;
}

export const getPostUrl = post => {
  const host = getHostName();
  return `${host}${constructPostSlugPath(post)}`;
};

export const getCollectionUrl = collection => {
  const host = getHostName();
  return `${host}/collections/${collection._id}/${collection.slug || ""}`;
};

export const formatToFriendlyNumber = number => humanFormat(number, { decimals: 1, separator: "" });

export const constructUserProfilePath = (user = {}) => {
  const { id, username } = user || {}; // destructing the params didn't work for me
  return !!username ? `/user/${username}` : `/profile/${id}`;
};

export const constructPostSlugPath = post => {
  const { slug, _id } = post;
  return slug ? `/case/${slug}` : `/posts/${_id}`;
};

export const shuffle = arr => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

export const getMobileOS = () => {
  if (!IS_CLIENT_RENDERED) {
    return null;
  }

  if (/iPhone|iPad/.test(window.navigator.userAgent)) {
    return MOBILE_OSES.IOS;
  } else if (window.navigator.userAgent.includes("Android")) {
    return MOBILE_OSES.ANDROID;
  }
  return null;
};

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
};

export const checkIfMobile = () => (IS_CLIENT_RENDERED ? window.innerWidth <= 640 : true);

export const checkIfDesktop = () => (IS_CLIENT_RENDERED ? window.innerWidth > 1024 : false);

export const getReduxDevtoolsExtensionCompose = () => {
  return IS_CLIENT_RENDERED ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : "";
};



// WEBPACK FOOTER //
// ./src/util/index.js